// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import utilsObj from "@/utils/utils.js";
import sensorsdata from "@/utils/autotrack.js";
import "lib-flexible/flexible";
import VueLazyload from "vue-lazyload";
import Meta from "vue-meta";
import store from "@/store";
import Vuebar from "vuebar";
import Router from "vue-router";
import "./utils/remFlex";
// import scroll from 'vue-seamless-scroll'
// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole)
sensorsdata(); // 开启神策统计
// Vue.use(scroll)
Vue.use(Router);
Vue.use(VueLazyload);
Vue.use(Meta);
Vue.use(Vuebar);
Vue.config.productionTip = false;
Vue.use(VueLazyload, {
  // loading: 'dist/loading.gif', // 为图片加载前展示的默认图片路径
});
// 截图插件
Vue.prototype.utilsObj = utilsObj;
Vue.filter("ticketsFilter", function(num, trans) {
  if (trans && +num >= 10000) {
    return utilsObj.formatNumToGreat(num);
  }
  return (+num || 0)
    .toString()
    .replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
});
const flag = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
const ismobile = flag ? 1 : 0;
if (ismobile == 1) {
  store.dispatch("GetNativeObject"); // sotre获取原生对象
}
router.beforeEach((to, from, next) => {
  console.log(from, to);
  // 电脑
  if (ismobile == 0) {
    console.log("no", ismobile);
    require("./style/public_pc.css");
    if (to.path.indexOf("Mobile") > 0) {
      next({ path: to.path.split("Mobile")[0] + "Pc", query: to.query });
    } else if (to.path.indexOf("Pc") < 0) {
      next({ path: to.path + "Pc", query: to.query });
    } else {
      next();
    }
  }

  // 手机
  if (ismobile == 1) {
    console.log("yes", ismobile);
    require("./style/public.css");
    if (to.path.indexOf("Pc") > 0) {
      next({ path: to.path.split("Pc")[0], query: to.query });
    } else if (to.path.indexOf("Mobile") > 0) {
      next({ path: to.path.split("Mobile")[0], query: to.query });
    } else {
      next();
    }
  }
});
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js